<template>
  <div class="container">
    <b-modal
      ref="bill-gift-product-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="xl"
    >
      <v-form ref="form">
        <b-row class="mb-4">
          <b-col md="12">
          <div class="gift-quantity-title">
            Số lượng sản phẩm quà tặng cho phép:
            <span class="text-primary font-weight-bold">{{
              displayMaxQuantity
            }}</span>
          </div>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col md="4">
            <b-input
              size="sm"
              placeholder="Tìm kiếm"
              v-model="searchText"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col md="1">
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <b-table
          :items="listItem"
          :fields="fields"
          :busy="onLoading"
          bordered
          hover
          show-empty
          class="product-table"
        >
          <template #empty="scope">
            <h5 class="text-center">
              Không có sản phẩm quà tặng nào được gợi ý
            </h5>
          </template>
          <template v-slot:head(selected)>
            <span>
              <b-form-checkbox
                v-model="isCheckAll"
                size="lg"
                @change="clickAll"
              ></b-form-checkbox>
            </span>
          </template>
          <!-- check bõ -->
          <template v-slot:cell(selected)="row">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                size="lg"
                v-model="row.item.checked"
                @change="clickIndex()"
                :disabled="row.item.quantityInStock === 0"
              ></b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(id)="row">
            <div>
              <span
                v-text="row.item.id"
                class="d-flex justify-content-center"
              ></span>
            </div>
          </template>
          <template v-slot:cell(productName)="row">
            <div style="display: flex; gap: 8px; align-items: center">
              <ProductImage :src="row.item.productImageUrl" />
              <div>
                <span
                  v-text="row.item.barCode"
                  style="font-size: 12px"
                  v-show="row.item.barCode"
                ></span
                ><br />
                <span
                  v-text="row.item.productCode"
                  style="font-size: 13px"
                  v-show="row.item.productCode"
                ></span
                ><br />
                <span
                  v-text="row.item.productName"
                  style="white-space: normal; color: #3699ff; font-size: 13px"
                ></span>
              </div>
            </div>
          </template>
          <template v-slot:cell(quantity)="row">
            <div>
              <BInputNumber
                size="sm"
                v-model="row.item.quantity"
                :min="1"
                :max="row.item.quantityInStock"
                :disabled="row.item.quantityInStock === 0"
              ></BInputNumber>
            </div>
          </template>
        </b-table>
        <b-button
          style="font-weight: 600; width: 100px"
          variant="primary"
          size="sm"
          @click="submit"
          >Áp dụng</b-button
        >
        <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal"
        >
          Hủy
        </b-button>
      </v-form>
    </b-modal>
  </div>
</template>

<style scoped>
.gift-quantity-title {
  font-size: 1.1rem;
  color: #181c32;
}

.product-table /deep/ th {
  text-align: center;
  font-weight: 600;
  color: '#181c32';
}
</style>

<script>
import { convertPrice, xoa_dau, makeToastFaile } from '@/utils/common';
import { BILL_ITEM_TYPE } from '@/utils/enum';
import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name';
import { v4 } from 'uuid';
import { cloneDeep } from 'lodash';
import ProductImage from '@/view/components/products/ProductImage.vue';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';

export default {
  props: ['billItemId', 'productName', 'storeId', 'productId', 'listGiftProducts'],
  data() {
    return {
      DISCOUNT_AMOUNT_TYPE_NAME,
      modalTitle: '',
      searchText: '',
      listItem: [],
      listItemDraff: [],
      fields: [
        {
          key: 'selected',
          label: '',
          sortable: false,
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          sortable: false,
        },
        {
          key: 'quantityInStock',
          label: 'Tồn',
          sortable: false,
          tdClass: 'text-right',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          sortable: false,
          tdClass: 'text-right',
        },
        { key: 'accessoryGroupName', label: 'Tên chương trình' },
      ],
      isCheckAll: false,
      onLoading: false,
      maxQuantity: 0,
    };
  },
  components: {
    ProductImage,
    BInputNumber,
  },
  computed: {
    displayMaxQuantity() {
      if (
        this.maxQuantity === Infinity ||
        this.maxQuantity === -Infinity ||
        isNaN(this.maxQuantity)
      ) {
        return 0
      }
      return this.maxQuantity
    },
  },
  methods: {
    convertPrice,
    showModal: function () {
      this.searchText = '';
      const maxQuantityItems = this.listGiftProducts.map((item) => item.maxQuantity);
      this.maxQuantity = Math.max(...maxQuantityItems);
      this.listItem = this.listGiftProducts.map((item) => {
        return {
              id: v4(),
              checked: false,
              itemType: BILL_ITEM_TYPE.PRODUCT_BONUS,
              belongBillDetailId: this.billItemId,
              quantity: 1,
              ...item,
            };
      })
      this.listItemDraff = cloneDeep(this.listItem);
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Thêm sản phẩm quà tặng cho sản phẩm: <a class='text-primary'>#${this.productName}</a></span>
              </div>`;
      this.$refs['bill-gift-product-modal'].show();
    },
    hideModal: function () {
      this.$refs['bill-gift-product-modal'].hide();
    },
    clickAll() {
      this.listItem.forEach((item) => {
        item.checked = this.isCheckAll;
      });
    },
    clickIndex() {
      this.isCheckAll = this.listItem.every((item) => item.checked);
    },
    onFilter() {
      const textSearch = this.searchText ? this.searchText.trim() : '';
      this.listItem = this.listItemDraff
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.name);
          return (
            nameNoneSign.toLowerCase().indexOf(textSearch.toLowerCase()) > -1 ||
            item.name.toLowerCase().indexOf(textSearch.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
    },
    submit() {
      const listResult = this.listItem.filter((item) => item.checked);
      const quantityItems = listResult.map((item) => item.quantity);
      const totalQuantity = quantityItems.reduce((acc, curr) => acc + curr, 0);
      if (totalQuantity > this.maxQuantity) {
        makeToastFaile('Số lượng sản phẩm quà tặng vượt quá số lượng sản phẩm cho phép!');
        return;
      }
      this.$emit('addGiftList', listResult);
      this.hideModal();
    },
  },
};
</script>
